// extracted by mini-css-extract-plugin
export default {"container":"v0-z","heading":"w0-z","links":"x0-z","copy":"y0-z","subCopy":"z0-z","linksLeft":"A0-z","linksCenter":"B0-z","linksRight":"C0-z","link":"D0-z","onlyLink":"E0-z"};